import { Button } from "@/components/Button"
import { Expense3DSPassword } from "@/components/Cards/Create/Expense/3DSPassword"
import { Image } from "@/components/common/Image"
import { OTPInput } from "@/components/Form/OPTInput"
import { Modal } from "@/components/Modal"
import { useCardPassword } from "@usher/pe-client-front-end-lib"
import { Fragment, useState } from "react"
import { FormProvider } from "react-hook-form"
import { FormattedMessage, useIntl } from "react-intl"

const ConfirmTowFactor = () => {
  return (
    <div className="mb-4">
      <p className="text-base mt-4 mb-2.5 font-bold">For your security, please confirm your identity before updating your PIN.</p>
      <label>Enter the 2FA code to change your PIN</label>
      <OTPInput placeholder="___-___-___" className="max-w-[300px] sm:w-[400px]" />
    </div>
  )
}
export const checker = (data: unknown) => {
  return new Promise((resolve) => {
    setTimeout(
      () => {
        resolve(data)
      },
      1000 + (Math.round(Math.random() * 5) + 1) * 100,
    )
  })
}
export const CardActionPassword = () => {
  const { $t: t } = useIntl()
  const [open, setOpen] = useState(false)
  const { changePINCode, formMethods, fetching } = useCardPassword({
    onSuccess: () => {
      setOpen(false)
    },
  })

  return (
    <>
      <button className="btn-modal" onClick={() => setOpen(true)}>
        <Image src="editing.svg" />
        <FormattedMessage id="change-pin" />
      </button>

      <Modal title={t({ id: "change-pin" })} onClose={() => setOpen(false)} show={open}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(changePINCode)} className="w-full sm:min-w-[439px]">
            <Fragment>
              <Expense3DSPassword withoutPhone control={formMethods.control} />
            </Fragment>

            <Button loading={fetching} type="submit">
              <FormattedMessage id="pa_195" />
            </Button>
          </form>
        </FormProvider>
      </Modal>
    </>
  )
}
